import { isString } from 'lodash';
import { FileField } from '@shared/data/entity/fields/FileField';
import { i18n } from '@shared/util/i18n';
import { isImage } from '@shared/util/media/type';

/** A file field as one line of text, summarized by kind: "2 images, 1 file". */
export function getFileText(field: FileField): string {
  const imageCount = field.files.filter(isImage).length;
  const fileCount = field.files.length - imageCount;
  return [
    imageCount > 0 && i18n('card.blocks.subtableInput.imageCount', { count: imageCount }),
    fileCount > 0 && i18n('card.blocks.subtableInput.fileCount', { count: fileCount }),
  ]
    .filter(isString)
    .join(', ');
}
